import React from "react";
import Icon from "./Icon";

function ConfirmDelete({ message, onConfirm, onCancel }) {
  return (
    <div className="modal-backdrop" style={{zIndex:300}} onClick={e=>e.target===e.currentTarget&&onCancel()}>
      <div className="modal" style={{maxWidth:400}}>
        <div className="modal-header">
          <div>
            <div className="modal-title" style={{color:"var(--red)",display:"flex",alignItems:"center",gap:8}}>
              <Icon name="trash" size={18}/>Confirmer la suppression
            </div>
            <div className="modal-sub">Cette action est irréversible</div>
          </div>
        </div>
        <div className="modal-body">
          <p style={{fontSize:14,color:"var(--text-2)",lineHeight:1.6}}>{message}</p>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onCancel}>Annuler</button>
          <button className="btn btn-danger" onClick={onConfirm}><Icon name="trash" size={14}/>Supprimer</button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDelete;
